import { ICollectionTile } from "@faire/web-api/indigofair/data/ICollectionTile";
import React, { PropsWithChildren } from "react";

import { CollectionTileClickImpressionContext } from "@faire/retailer/hooks/CollectionTileImpression/CollectionTileClickImpressionContext";
import { CollectionTileViewImpressionProvider } from "@faire/retailer/hooks/CollectionTileImpression/CollectionTileViewImpressionProvider";

interface ICollectionTileImpressionProviderProps {
  contextToken: string | undefined;
  requestId: string | undefined;
  screenContext: ICollectionTile.Screen | undefined;
  containerContext: ICollectionTile.ScreenContainer | undefined;
}

export const CollectionTileImpressionProvider: React.FC<
  PropsWithChildren<ICollectionTileImpressionProviderProps>
> = ({
  children,
  contextToken,
  requestId,
  screenContext,
  containerContext,
}) => {
  const value = {
    contextToken,
    requestId,
    screenContext,
    containerContext,
  };
  return (
    <CollectionTileViewImpressionProvider {...value}>
      <CollectionTileClickImpressionContext.Provider value={value}>
        {children}
      </CollectionTileClickImpressionContext.Provider>
    </CollectionTileViewImpressionProvider>
  );
};
